export default __webpack_public_path__ + "static/media/table-unlock.9fc0f7bc.svg";